export enum PayorderBackendErrorMessage {
  NotFound = 'Could not find order with order number.',
  AmountAlreadyPaid = 'Order has already been paid.',
  OrderHasPendingPayment = 'PayOrder encountered an error while attempting to get remaining payment details from SAPI.',
  OrderDetailsNotFound = 'PayOrder encountered an error while attempting to get order details from SAPI.',
  OrderIsCancelled = 'Payment can not be processed for a canceled order.',
  OrderCannotBePaidOnline = 'Payment cannot be handled via PayOrder.',
  EmailAddressIsMissing = 'Required information is missing, email.',
  FailedToValidateToken = 'Failed to validate token.',
  TaxInformationIsMissing = 'Required tax information is missing.',
  PayorderAggregateNotFound = 'Payorder aggregate could not be found.',
  BillingContactIsMissing = 'Required information is missing, billing contact.',
}
